import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box, Link as MuiLink } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { helpStyles } from '../Help';

import personalRegister from '../../../img/help/help_register_personal.jpg';
import businessRegister from '../../../img/help/help_register_business.jpg';

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    ...helpStyles,
}));

const HelpRegister = ({ business = false }) => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Typography variant="body1" className={classes.helpLine}>
                ・画面右上、『
                <Link to="/register" className={classes.helpLink}>
                    新規登録
                </Link>
                』を選択してアカウント作成画面に移動します
            </Typography>

            <Typography variant="body1" className={classes.helpLine}>
                ・アカウントタイプは『{business ? '企業・雇用主' : '求職者'}』を選択し、その他項目を入力してアカウントを作成してください
            </Typography>

            <Box className={classes.helpImage}>
                <img
                    src={business ? businessRegister : personalRegister}
                    alt="Registration guide"
                    className={classes.helpImageStyle}
                />
            </Box>

            <Typography variant="body1" className={classes.helpWarningText}>
                ※アカウントタイプは後で変更できません。間違えて作成した場合は、一度アカウントを削除して改めて新規登録してください。
            </Typography>
        </Box>
    )
}

export default HelpRegister
